import React, { useContext, useEffect, useRef, useState } from "react";
import { AuthContext } from "../../../../../../Base/Context/AuthContext/AuthContext";
import { useForm } from "../../../../../../Base/Hooks/useForm";
import { getEstadosCategory } from "../../../../../../API/Global/Status/StatusRequests";
import { getAreasAct } from "../../../../../../Base/API/Global/Areas/AreasRequests";
import {
  editarRed,
  getClaseRed,
  getMarcas,
  getTipoDispositivos,
  getTipoRed,
  guardarRed,
} from "../../../../../../API/IT/Dispositivos/DispositivosRequest";
import { Button } from "primereact/button";
import { InputTextarea } from "primereact/inputtextarea";
import AutoCompleteDropdown from "../../../../../../Base/Components/Form/AutoCompleteDropdown";
import { InputText } from "primereact/inputtext";
import { Dialog } from "primereact/dialog";
import Loader from "../../../../../../Base/Components/Loader/Loader";
import { Toast } from "primereact/toast";
import { getActivosFijos } from "../../../../../../API/Global/ActivosFijos/ActivosFijosRequest";
import { getPersonalRecibeProducto } from "../../../../../../API/RRHH/Personal/PersonalRequests";
import { toastShow } from "../../../../../../Base/Services/ToastService";

const RedCRUD = ({ listRedes, showDialog, red, setShowDialog, getInfo }) => {
  const { userAuth } = useContext(AuthContext);
  const toast = useRef(null);

  const [loading, setLoading] = useState(false);
  const [estados, setEstados] = useState([]);
  const [marcas, setMarcas] = useState([]);
  const [areas, setAreas] = useState([]);
  const [tipoDispositivos, setTipoDispositivos] = useState([]);
  const [tipoRed, setTipoRed] = useState([]);
  const [claseRed, setClaseRed] = useState([]);
  const [activos, setActivos] = useState([]);
  const [personal, setPersonal] = useState([]);

  const initialValues = {
    IdRed: -1,
    IdEstado: red ? red?.IdEstado : 5,
  };

  const { values, handleInputChange, setValues, resetForm, error, setError } =
    useForm(initialValues);

  const getValoresIniciales = async () => {
    setLoading(true);

    const marcasTempo = await getMarcas();
    setMarcas(marcasTempo);

    const areasTempo = await getAreasAct();
    setAreas(areasTempo);

    const tipoDispositivoTempo = await getTipoDispositivos();
    setTipoDispositivos(tipoDispositivoTempo);

    const tipoRedTempo = await getTipoRed();
    // const tipoRedFilter = tipoRedTempo.filter((e) =>
    //   [1, 4].includes(e?.IdTipoRed)
    // );
    setTipoRed(tipoRedTempo);

    const claseRedTempo = await getClaseRed();
    setClaseRed(claseRedTempo);

    const activosTempo = await getActivosFijos();
    const activosFilter = activosTempo.filter((e) =>
      [47].includes(e?.IdTipoActivo)
    );
    setActivos(activosFilter);

    const personalTempo = await getPersonalRecibeProducto();
    setPersonal(personalTempo);

    const estadosTempo = await getEstadosCategory("General");
    setEstados(estadosTempo);

    const estadoActivo =
      red?.IdRed > 0
        ? estadosTempo.find((e) => e.IdStatus === red?.IdEstado)
        : estadosTempo.find((e) => e.IdStatus === 5);

    setValues({
      ...red,
      TipoDispositivo: tipoDispositivoTempo.find(
        (t) => red?.IdTipoDispositivo === t?.IdTipoDispositivo
      ),
      TipoRed: tipoRedTempo.find((t) => red.IdTipoRed === t?.IdTipoRed),
      ClaseRed: claseRedTempo.find((c) => red.IdClaseRed === c?.IdClase),
      Marca: marcasTempo.find((m) => red?.IdMarca === m.IdMarca),
      Area: areasTempo.find((a) => red?.IdArea === a.IdArea),
      Activo: activosTempo.find((a) => red?.IdActivo === a.IdActivo),
      Personal: personalTempo.find((p) => red?.IdAsignado === p.IdPersonal),
      Estado: estadoActivo,
    });

    setLoading(false);
  };

  const verificarInfo = () => {
    let error = {};
    if (!values.NombreDispositivo) {
      error.NombreDispositivo = true;
      error.error = true;
    }
    setError(error);
    return error;
  };

  const verificarDuplicado = () => {
    const duplicado = listRedes.find(
      (r) => r.IdRed !== values.IdRed && r.DireccionIP === values?.DireccionIP
    );

    if (duplicado) {
      let mensaje = "Ya existe una IP con el mismo valor de: ";
      if (duplicado.DireccionIP === values.DireccionIP)
        mensaje += `${duplicado.DireccionIP} `;
      return mensaje;
    }

    return null;
  };

  const agregar = async () => {
    const e = verificarInfo();
    if (!e.error) {
      const duplicado = verificarDuplicado();

      if (duplicado) {
        toastShow(toast, "error", "Error", duplicado);
        return;
      }
      const Datos = {
        IdRed: values?.IdRed,
        DireccionIP: values?.DireccionIP,
        NombreDispositivo: values?.NombreDispositivo,
        IdTipoDispositivo: values?.TipoDispositivo?.IdTipoDispositivo,
        IdTipoRed: values?.TipoRed?.IdTipoRed,
        IdClaseRed: values?.ClaseRed?.IdClase,
        IdMarca: values?.Marca?.IdMarca,
        Modelo: values?.modelo,
        Serie: values?.serie,
        IdArea: values?.Area?.IdArea,
        IdActivo: values?.Activo?.IdActivo,
        AnyDesk: values?.AnyDesk,
        ClaveAnyDesk: values?.ClaveAnyDesk,
        IdAsignado: values?.Personal?.IdPersonal,
        Comentario: values?.Comentario,
        IdEstado: values?.IdEstado,
        IdUserCreated: userAuth?.IdUser,
        IdUserEdit: userAuth?.IdUser,
      };

      setLoading(true);
      if (Datos.IdRed > 0) {
        const resultado = await editarRed(Datos);
        if (resultado[0]?.ESTADO === 1) {
          toastShow(toast, "success", "Datos Editados", resultado[0]?.MENSAJE);
          getInfo();
          setTimeout(() => {
            onHide();
            setLoading(false);
          }, 1300);
        } else {
          toastShow(toast, "error", "Error al Editar", resultado[0]?.MENSAJE);
        }
      } else {
        const resultado = await guardarRed(Datos);
        if (resultado[0]?.ESTADO === 1) {
          toastShow(toast, "success", "Datos Agregados", resultado[0]?.MENSAJE);
          getInfo();
          setTimeout(() => {
            onHide();
            setLoading(false);
          }, 1300);
        } else {
          toastShow(toast, "error", "Error al agregar", resultado[0]?.MENSAJE);
        }
      }
    }
  };

  const onHide = () => {
    setShowDialog(false);
    resetForm();
    setError({});
  };

  const DialogFooter = (
    <React.Fragment>
      <Button
        label="Cancelar"
        icon="pi pi-times"
        className="p-button-text"
        onClick={onHide}
      />
      <Button
        label={red?.IdRred > 0 ? "Editar" : "Guardar"}
        icon="pi pi-check"
        className="p-button-text"
        onClick={() => {
          agregar();
        }}
        loading={loading}
      />
    </React.Fragment>
  );

  useEffect(() => {
    if (showDialog) {
      getValoresIniciales();
    }
  }, [showDialog]);

  const dialogTitle = red?.IdRed > 0 ? "Editar Red" : "Agregar Red";
  return (
    <div>
      <Dialog
        visible={showDialog}
        modal
        className="modal__contenedor1"
        footer={DialogFooter}
        onHide={onHide}
        header={dialogTitle}
        style={{ width: "60%" }}
      >
        <div id="Dialog">
          <Loader loading={loading} querySelector={"#Dialog"} />
          <div style={{ margin: "auto" }}>
            <Toast ref={toast} style={{ zIndex: 50000 }} />

            <div className="modal__input-contenedor gap-2">
              <div className="field col-4">
                <span className="p-float-label">
                  <InputText
                    name="DireccionIP"
                    value={values?.DireccionIP}
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                    labelStyle={{
                      color: "gray",
                      textShadow: "0px 0px 1px white",
                    }}
                    className={error.DireccionIP ? "p-invalid" : ""}
                  />
                  <label htmlFor="DireccionIP">IP</label>
                </span>
              </div>

              <div className="field col-4">
                <span className="p-float-label">
                  <InputText
                    name="NombreDispositivo"
                    value={values?.NombreDispositivo}
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                    labelStyle={{
                      color: "gray",
                      textShadow: "0px 0px 1px white",
                    }}
                    className={error.NombreDispositivo ? "p-invalid" : ""}
                  />
                  <label htmlFor="NombreDispositivo">Nombre Dispositivo</label>
                </span>
              </div>

              <div className="field col-4">
                <span className="p-float-label">
                  <AutoCompleteDropdown
                    name={"Area"}
                    value={values?.Area}
                    items={areas}
                    field={"Area"}
                    label={"Area"}
                    handleInputChange={handleInputChange}
                    abelStyle={{
                      color: "gray",
                      textShadow: "0px 0px 1px white",
                    }}
                    className={error.IdArea ? "p-invalid" : ""}
                  />
                </span>
              </div>

              {/* <div className="field col-4">
                <span className="p-float-label">
                  <AutoCompleteDropdown
                    name={"Estado"}
                    value={values.Estado}
                    items={estados}
                    field={"StatusName"}
                    label={"Estado"}
                    handleInputChange={handleInputChange}
                    abelStyle={{
                      color: "gray",
                      textShadow: "0px 0px 1px white",
                    }}
                    className={error.IdEstado ? "p-invalid" : ""}
                  />
                </span>
              </div> */}
            </div>

            <div className="modal__input-contenedor gap-2">
              <div className="field col-4">
                <span className="p-float-label">
                  <AutoCompleteDropdown
                    name={"TipoDispositivo"}
                    value={values?.TipoDispositivo}
                    items={tipoDispositivos}
                    field={"TipoDispositivo"}
                    label={"Tipo Dispositivo"}
                    handleInputChange={handleInputChange}
                    abelStyle={{
                      color: "gray",
                      textShadow: "0px 0px 1px white",
                    }}
                    className={error.IdTipoDispositivo ? "p-invalid" : ""}
                  />
                </span>
              </div>

              <div className="field col-4">
                <span className="p-float-label">
                  <AutoCompleteDropdown
                    name={"TipoRed"}
                    value={values?.TipoRed}
                    items={tipoRed}
                    field={"NombreRed"}
                    label={"Tipo Red"}
                    handleInputChange={handleInputChange}
                    abelStyle={{
                      color: "gray",
                      textShadow: "0px 0px 1px white",
                    }}
                    className={error.IdTipoRed ? "p-invalid" : ""}
                  />
                </span>
              </div>

              <div className="field col-4">
                <span className="p-float-label">
                  <AutoCompleteDropdown
                    name={"ClaseRed"}
                    value={values?.ClaseRed}
                    items={claseRed}
                    field={"ClaseRango"}
                    label={"Clase Red"}
                    handleInputChange={handleInputChange}
                    abelStyle={{
                      color: "gray",
                      textShadow: "0px 0px 1px white",
                    }}
                    className={error.IdClaseRed ? "p-invalid" : ""}
                  />
                </span>
              </div>

              {/* <div className="field col-4">
                <span className="p-float-label">
                  <AutoCompleteDropdown
                    name={"Marca"}
                    value={values?.Marca}
                    items={marcas}
                    field={"Marca"}
                    label={"Marca"}
                    handleInputChange={handleInputChange}
                    abelStyle={{
                      color: "gray",
                      textShadow: "0px 0px 1px white",
                    }}
                    className={error.IdMarca ? "p-invalid" : ""}
                  />
                </span>
              </div> */}

              {/* <div className="field col-4">
                <span className="p-float-label">
                  <InputText
                    name="modelo"
                    value={values?.modelo}
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                    labelStyle={{
                      color: "gray",
                      textShadow: "0px 0px 1px white",
                    }}
                    className={error.modelo ? "p-invalid" : ""}
                  />
                  <label htmlFor="modelo">Modelo</label>
                </span>
              </div> */}
            </div>

            <div className="modal__input-contenedor gap-2">
              <div className="field col-4">
                <span className="p-float-label">
                  <AutoCompleteDropdown
                    name={"Marca"}
                    value={values?.Marca}
                    items={marcas}
                    field={"Marca"}
                    label={"Marca"}
                    handleInputChange={handleInputChange}
                    abelStyle={{
                      color: "gray",
                      textShadow: "0px 0px 1px white",
                    }}
                    className={error.IdMarca ? "p-invalid" : ""}
                  />
                </span>
              </div>

              <div className="field col-4">
                <span className="p-float-label">
                  <InputText
                    name="modelo"
                    value={values?.modelo}
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                    labelStyle={{
                      color: "gray",
                      textShadow: "0px 0px 1px white",
                    }}
                    className={error.modelo ? "p-invalid" : ""}
                  />
                  <label htmlFor="modelo">Modelo</label>
                </span>
              </div>

              <div className="field col-4">
                <span className="p-float-label">
                  <InputText
                    name="serie"
                    value={values?.serie}
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                    labelStyle={{
                      color: "gray",
                      textShadow: "0px 0px 1px white",
                    }}
                    className={error.serie ? "p-invalid" : ""}
                  />
                  <label htmlFor="serie">Serie</label>
                </span>
              </div>
            </div>

            <div className="modal__input-contenedor gap-2">
              <div className="field col-4">
                <span className="p-float-label">
                  <AutoCompleteDropdown
                    name={"Activo"}
                    value={values?.Activo}
                    items={activos}
                    field={"NombreActivo"}
                    label={"Activo"}
                    handleInputChange={handleInputChange}
                    abelStyle={{
                      color: "gray",
                      textShadow: "0px 0px 1px white",
                    }}
                    className={error.IdActivo ? "p-invalid" : ""}
                  />
                </span>
              </div>

              <div className="field col-4">
                <span className="p-float-label">
                  <InputText
                    name="AnyDesk"
                    value={values?.AnyDesk}
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                    labelStyle={{
                      color: "gray",
                      textShadow: "0px 0px 1px white",
                    }}
                    className={error.AnyDesk ? "p-invalid" : ""}
                  />
                  <label htmlFor="AnyDesk">AnyDesk</label>
                </span>
              </div>

              <div className="field col-4">
                <span className="p-float-label">
                  <InputText
                    name="ClaveAnyDesk"
                    value={values?.ClaveAnyDesk}
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                    labelStyle={{
                      color: "gray",
                      textShadow: "0px 0px 1px white",
                    }}
                    className={error.serie ? "p-invalid" : ""}
                  />
                  <label htmlFor="ClaveAnyDesk">Clave AnyDesk</label>
                </span>
              </div>
            </div>

            <div className="modal__input-contenedor gap-2">
              <div className="field col-4">
                <span className="p-float-label">
                  <AutoCompleteDropdown
                    name={"Personal"}
                    value={values?.Personal}
                    items={personal}
                    field={"NombreConcatenado"}
                    label={"Personal"}
                    handleInputChange={handleInputChange}
                    abelStyle={{
                      color: "gray",
                      textShadow: "0px 0px 1px white",
                    }}
                    className={error.IdAsignado ? "p-invalid" : ""}
                  />
                </span>
              </div>

              <div className="field col-8">
                <span className="p-float-label">
                  <InputTextarea
                    name="Comentario"
                    value={values?.Comentario}
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                    labelStyle={{
                      color: "gray",
                      textShadow: "0px 0px 1px white",
                    }}
                    rows={1}
                    className={error.Comentario ? "p-invalid" : ""}
                  />
                  <label htmlFor="Comentario">Comentario</label>
                </span>
              </div>
            </div>
          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default RedCRUD;
